/**
 * WASM 模块初始化和调用
 * 加载 Go WebAssembly 模块，并提供 GoGetAuth 函数接口
 */

let wasmReady = false;
let wasmError = null;
import { wasmBase64 } from "/public/wasm_inline";

/**
 * 初始化 WASM 模块
 * @returns {Promise&lt;void&gt;}
 */
export async function initWasm() {
	if (wasmReady) return;

	try {
		// 全局加载 wasm_exec.js（应该在 public/index.html 中加载）
		if (typeof window.Go === "undefined") {
			throw new Error("wasm_exec.js not loaded");
		}

		const go = new window.Go();

		// 加载 WASM 文件
		const response = await fetch(wasmBase64);
		const buffer = await response.arrayBuffer();

		const result = await WebAssembly.instantiate(buffer, go.importObject);
		// 运行 WASM (异步)

		go.run(result.instance);

		// 等待 GoGetAuth 函数注册到 window 对象
		await new Promise((resolve, reject) => {
			const checkReady = setInterval(() => {
				if (typeof window.GoGetAuth === "function") {
					clearInterval(checkReady);
					clearTimeout(timeoutId);
					wasmReady = true;
					resolve();
				}
			}, 50);

			// 超时保护：10秒
			const timeoutId = setTimeout(() => {
				clearInterval(checkReady);
				wasmError = "WASM initialization timeout";
				reject(new Error(wasmError));
			}, 10000);
		});
	} catch (error) {
		wasmError = error.message;
		console.error("WASM initialization failed:", error);
		throw error;
	}
}

/**
 * 获取 WASM 认证数据
 * @param {string} method - HTTP 方法 (GET, POST)
 * @param {string} params - 参数（query string 或 JSON string）
 * @returns {object} - { nonce, ts, sign }
 */
export function getWasmAuth(method, params = "") {
	if (!wasmReady) {
		throw new Error("WASM not ready. Call initWasm() first.");
	}

	if (typeof window.GoGetAuth !== "function") {
		throw new Error("GoGetAuth not found in window object");
	}

	return window.GoGetAuth(method, params);
}

/**
 * 检查 WASM 是否已初始化
 * @returns {boolean}
 */
export function isWasmReady() {
	return wasmReady;
}

/**
 * 获取 WASM 错误信息
 * @returns {string|null}
 */
export function getWasmError() {
	return wasmError;
}
